module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/up-left-bf8267efd760695af7cbda288880dd04.svg";